enum AutocompleteOptionType {
    HardSkill = 'HardSkill',
    SoftSkill = 'SoftSkill',
}

export default AutocompleteOptionType;
